import {
  BRANDS_REQUESTED,
  BRANDS_SUCCESS,
} from '../types';

const INITIAL_STATE = {
  brands: {},
  isFetching: false,
  status: 'waiting',
  errors: null
};

const brands = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case BRANDS_REQUESTED:
      return Object.assign({}, state, {
        brands: {},
        isFetching: true,
        status: 'requested',
        errors: null
      });

    case BRANDS_SUCCESS:
      return Object.assign({}, state, {
        brands: action.payload.brands || {},
        isFetching: false,
        status: 'success',
        errors: null
      });

    default:
      return state;
  }
}

export default brands;
